module.exports = __webpack_public_path__ + "static/media/isa5.f4d163d5.png";